var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"company-services"},[_c('div',{staticClass:"company-services-title"},[_vm._v(" "+_vm._s(_vm.$t('sp.registration.company.services.title'))+" ")]),_c('company-services-form',{attrs:{"value":_vm.spFreelancerServicesInfo},on:{"changed":_vm.formChanged}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }